import styles from "./staking-risk.module.css";

export default function ColoredStatistics({
  title = "% of Total Score",
  data = [],
}) {
  return (
    <div className={styles["statistic-wrapper"]}>
      <h1>{title}</h1>
      <div className={styles["statistic-content"]}>
        {data.map((item, index) => (
          <div
            key={index}
            className={styles["statistic-item"]}
            style={{ width: `${item.width}px` }}
          >
            <p>{item.label}</p>
            <div
               className={`${styles["bar"]} ${index === data.length - 1 ? styles["noAfter"] : ""}`}
              style={{
                width: `100%`,
                backgroundColor: item.color || "#ccc",
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <span>{item.value}%</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}